import { render, staticRenderFns } from "./product-admin.html?vue&type=template&id=54bc4091&scoped=true&"
import script from "./product-admin.js?vue&type=script&lang=js&"
export * from "./product-admin.js?vue&type=script&lang=js&"
import style0 from "./product-admin.scss?vue&type=style&index=0&id=54bc4091&prod&scoped=true&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=54bc4091&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bc4091",
  null
  
)

export default component.exports